var _path, _path2, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcasePortfolio1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1686 17.5031H5.83179C3.99008 17.5031 2.49707 16.0101 2.49707 14.1684V7.49893C2.49707 6.57808 3.24357 5.83157 4.16443 5.83157H15.836C16.7568 5.83157 17.5033 6.57808 17.5033 7.49893V14.1684C17.5033 16.0101 16.0103 17.5031 14.1686 17.5031Z",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 5.83158V4.16422C6.66602 3.24336 7.41252 2.49686 8.33338 2.49686H11.6681C12.589 2.49686 13.3355 3.24336 13.3355 4.16422V5.83158",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.33301,
    y: 9.16632,
    width: 3.33472,
    height: 2.50104,
    rx: 0.5,
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.668 10.4168H14.5859C16.1974 10.4168 17.5037 9.11043 17.5037 7.49893V7.49893",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33283 10.4168H5.41495C3.80345 10.4168 2.49707 9.11043 2.49707 7.49893V7.49893",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcasePortfolio1);
export default __webpack_public_path__ + "static/media/suitcase-portfolio-1.cd49a8a8401b61c7f8d872ea06e9c68d.svg";
export { ForwardRef as ReactComponent };